import CarouselSlide from './CarouselSlide';

export default CarouselSlide;
